/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import DualOrMultiAxisChartVisualization from './DualOrMultiAxisChartVisualization';

export default class DualAxisChartVisualization extends DualOrMultiAxisChartVisualization {

    finalOptionAdjustment(highchartsOptions: any): any {
        const options = highchartsOptions;
        const seriesCount = options.series.length;

        const series = options.series.map((item: any, index: number) => {
            const isLastSeriesItem = index === seriesCount - 1;

            return {
                ...item,
                type: isLastSeriesItem ? this.seriesType : 'column',
                yAxis: isLastSeriesItem ? 1 : 0
            }
        });

        const firstAxis = {
            ...options.yAxis,
            labels: {
                ...options.yAxis.labels,
                style: {
                    ...options.yAxis.labels.style,
                    color: options.colors[0]
                }
            },
            title: {
                ...options.yAxis.title,
                style: {
                    ...options.yAxis.title.style,
                    color: options.colors[0]
                }
            }
        };
        firstAxis.title.text = seriesCount === 2 ? series[0].name : '';

        const secondAxis = {
            ...firstAxis,
            opposite: true,
            labels: {
                ...firstAxis.labels,
                style: {
                    ...firstAxis.labels.style,
                    color: options.colors[seriesCount - 1]
                }
            },
            title: {
                ...firstAxis.title,
                text: series[seriesCount - 1].name,
                style: {
                    ...firstAxis.title.style,
                    color: options.colors[seriesCount - 1]
                }
            }
        };

        return super.finalOptionAdjustment({
            ...options,
            series,
            yAxis: [firstAxis, secondAxis]
        });
    }
}
